import { render, staticRenderFns } from "./exportedUdiList.vue?vue&type=template&id=556a20b4&scoped=true&"
import script from "./exportedUdiList.vue?vue&type=script&lang=js&"
export * from "./exportedUdiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a20b4",
  null
  
)

export default component.exports